var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import showToast from "../../services/toast";
import { useCollect } from "./hook/collect.hook";
import { CollectView } from "./view/collect.view";
var Collect = function () {
    var collect = useCollect();
    return (_jsxs(_Fragment, { children: [collect.toast.show &&
                showToast(position.topRight, collect.toast.type === "error" ? typeAlert.error : typeAlert.success, collect.toast.message, function () { return collect.closeToast(); }), _jsx(LoadingAFY, { loading: collect.loadingDetail, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), collect.hasDetail && _jsx(CollectView, __assign({}, collect))] }));
};
export default Collect;
